import React, { useState, useEffect } from "react";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Drawer, Grid, IconButton, List, ListItem, ListItemIcon, Menu, MenuItem, Tooltip, Typography, Badge } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./css/drawer.css";
import svgMenu from "../static/Íconos/X.svg";
import { Notificaciones } from "../request/request_home";

const useStyles = makeStyles((theme) => ({
    flexgrow: { flexGrow: 1 },
    toolbar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbarTitle: {
        flex: 1,
    },
    toolbarSecondary: {
        justifyContent: "space-between",
        overflowX: "auto",
    },
    toolbarLink: {
        padding: theme.spacing(1),
        flexShrink: 0,
    },

    drawerPaper: {
        background: "#182C20",
        width: window.screen.width <= 768 ? window.screen.width : 600,
    },
    drawer: {
        width: window.screen.width <= 768 ? window.screen.width : 600,
        flexShrink: 0,
    },
    drawerHeader: {
        alignContent: "center",
    },
    textDrawer: {
        color: "#929292",
        marginLeft: "14px",
    },
    textSubmenuDrawer: {
        color: "#DFDFDF",
        marginLeft: "2rem",
        fontWeight: "bold",
    },
    punteroIcono: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    itemList: {
        marginLeft: "10%",
        marginRight: "7%",
    },
    userLogin: {
        color: theme.palette.secondary.light,
    },
    modalContent: {
        backgroundColor: theme.palette.primary.main,
    },
    modalActions: {
        backgroundColor: theme.palette.primary.main,
        textAlign: "center",
    },
    textoError: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
        textAlign: "center",
    },
    texto: {
        color: theme.palette.common.white,
    },
    buttonModal: {
        width: 150,
        color: "#FFFFFF",
        fontSize: "12px",
        fontFamily: "Verdana Bold",
        borderRadius: 8,
        opacity: "200%",
        background: "linear-gradient(900deg, #F7D00E 30%, #A68A30 90%)",
        paddingTop: 8,
        paddingBottom: 8,
        "&:hover": {
            background: "#DFDFDF",
        },
    },
    typographyMenu: {
        marginLeft: "1rem",
        fontSize: "8pt",
    },
    textoHeader: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
        textAlign: "center",
    },
    iconClose: {
        color: theme.palette.secondary.contrastText,
    },
    divider: {
        height: "8px",
        backgroundColor: theme.palette.secondary.dark,
        width: "15%",
    },
    dividerItemMenu: {
        backgroundColor: "#929292",
        marginLeft: "9%",
        width: "80%",
    },
    customBadge: {
        backgroundColor: "#A68A30",
        color: "white",
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiTypography: {
            root: {
                fontSize: "10pt",
            },
        },
    },
});

export default function DrawerComponent(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const selector = useSelector((store) => store);
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));
    const { globalNotificaciones, setGlobalNotificaciones } = props;

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [userLogin, setUserLogin] = useState(selector.user.username);
    const [openConfrimacionLogout, setOpenConfirmacionLogout] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [ancho, setAncho] = useState(window.screen.width);

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickMenuMiPerfil = () => {
        setAnchorEl(null);
        dispatch({ type: "LOAD_TAB_MIPERFIL", data: 1 });
        dispatch({ type: "DRAWER_OPERATION", status: false });
        history.push("/perfil");
    };

    const handleClickMenuMisReservas = () => {
        setAnchorEl(null);
        dispatch({ type: "LOAD_TAB_MIPERFIL", data: 3 });
        dispatch({ type: "DRAWER_OPERATION", status: false });
        history.push("/perfil");
    };

    const handleDrawerClose = () => {
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    //inicio enevntos abrir y cerrar opciones de menu desplegables

    const handleClickCatalogoHabitaciones = () => {
        history.push("/habitaciones");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickReservar = () => {
        history.push("/cabaret_parisien");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickPromociones = () => {
        history.push("/promociones");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickRestaurantes = () => {
        history.push("/restaurantes");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickBares = () => {
        history.push("/bares");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickPiscinas = () => {
        history.push("/piscinas");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickQuienesSomos = () => {
        history.push("/quienes_somos");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickComentarios = () => {
        history.push("/comentarios_noticias/comentarios");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickNoticias = () => {
        history.push("/comentarios_noticias/noticias");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickGaleria = () => {
        history.push("/galeria_fotos");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickHistoria = () => {
        history.push("/historia");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };
    
    //? Work here areyesarean
    // const handleClickEventos = () => {
    //     var urlEventos = "https://eventos.hotelnacional.tur.cu/";
    //     var win = window.open(urlEventos, "_blank");
    //     win.focus();
    //     dispatch({ type: "DRAWER_OPERATION", status: false });
    // };

    const handleClickContactos = () => {
        history.push("/contactos");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickTerminosCondiciones = () => {
        history.push("/legales/terminos_condiciones");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const handleClickHome = () => {
        history.push("/");
        dispatch({ type: "DRAWER_OPERATION", status: false });
    };

    const onClickLogin = () => {
        dispatch({ type: "DRAWER_OPERATION", status: false });
        dispatch({ type: "DRAWER_OPERATION_LOGIN", status: true });
    };

    const onClickNotificacion = () => {
        if (selector.user.accessToken && selector.user.accessToken !== "") {
            Notificaciones(globalLang, selector.user.accessToken)
                .then((item) => {
                    setGlobalNotificaciones(item);
                })
                .finally(() => {
                    dispatch({ type: "DRAWER_OPERATION", status: false });
                    dispatch({ type: "DRAWER_OPERATION_NOTIFICACION", status: true });
                });
        } else {
            dispatch({ type: "DRAWER_OPERATION", status: false });
            dispatch({ type: "DRAWER_OPERATION_LOGIN", status: true });
        }
    };

    const handleClickLogout = () => {
        setOpenConfirmacionLogout(true);
    };

    const handleClickCloseModalCerrarSesion = () => {
        dispatch({ type: "LOGOUT_USER", accessToken: "", username: "" });
        setGlobalNotificaciones([]);
        setOpenConfirmacionLogout(false);
        setAnchorEl(null);
        dispatch({ type: "DRAWER_OPERATION", status: false });
        history.push("/");
    };

    const handleClickCancelModalCerrarSesion = () => {
        setOpenConfirmacionLogout(false);
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------

    useEffect(() => {
        setUserLogin(selector.user.username);
    }, [selector.user.username]);

    useEffect(() => {
        window.addEventListener("resize", function () {
            setAncho(window.screen.width);
        });
    }, []);

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Drawer
                    className={classes.drawer}
                    variant="temporary"
                    anchor="right"
                    open={selector.user.open_drawer}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    onEscapeKeyDown={handleDrawerClose}
                    onBackdropClick={handleDrawerClose}
                >
                    {/* Header */}
                    <Grid container>
                        <Grid item xs={1} sm={2} />
                        <Grid item container xs={10} sm={8} spacing={2}>
                            <Grid item container alignItems="center" justify="center" style={{ paddingTop: 20 }}>
                                <Grid item xs={5} container alignItems="center" justify="center">
                                    <Grid item xs={1} container alignItems="center" justify="center">
                                        <Tooltip title={<FormattedMessage id="notificaciones" />} placement="bottom">
                                            <Badge
                                                overlap="circle"
                                                color="primary"
                                                badgeContent=" "
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "right",
                                                }}
                                                variant="dot"
                                                classes={{ badge: classes.customBadge }}
                                                invisible={globalNotificaciones.length === 0 ? true : false}
                                            >
                                                <img
                                                    alt=""
                                                    style={{
                                                        height: "25px",
                                                        width: "25px",
                                                    }}
                                                    className={classes.punteroIcono}
                                                    src={require("../static/Íconos/Notificaciones.svg")}
                                                    onClick={onClickNotificacion}
                                                />
                                            </Badge>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={11} container alignItems="center" justify="flex-start" style={{ paddingLeft: 10 }}>
                                        {userLogin === undefined || userLogin === "undefined" || userLogin === "" ? (
                                            <Tooltip title={<FormattedMessage id="iniciar_sesión" />} placement="right">
                                                <img
                                                    alt=""
                                                    style={{
                                                        height: "25px",
                                                        width: "25px",
                                                    }}
                                                    className={classes.punteroIcono}
                                                    src={require("../static/Íconos/Perfil.svg")}
                                                    onClick={onClickLogin}
                                                />
                                            </Tooltip>
                                        ) : (
                                            <>
                                                <Tooltip title={<FormattedMessage id="menu" />} placement="right">
                                                    <img
                                                        alt=""
                                                        style={{
                                                            height: "25px",
                                                            width: "25px",
                                                        }}
                                                        className={classes.punteroIcono}
                                                        src={require("../static/Íconos/Perfil.svg")}
                                                        onClick={handleClick}
                                                    />
                                                </Tooltip>
                                                <Menu
                                                    id="simple-menu"
                                                    anchorEl={anchorEl}
                                                    keepMounted
                                                    open={Boolean(anchorEl)}
                                                    onClose={handleClose}
                                                    transformOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "center",
                                                    }}
                                                >
                                                    <MenuItem onClick={handleClickMenuMiPerfil}>
                                                        <img alt="user" src={require("../static/Íconos/user dorado.svg")} style={{ height: "15px", width: "15px" }} />
                                                        <Typography className={classes.typographyMenu}>
                                                            <FormattedMessage id="mi_perfil" />
                                                        </Typography>
                                                    </MenuItem>
                                                    <Divider />
                                                    <MenuItem onClick={handleClickMenuMisReservas}>
                                                        <img alt="reservas" src={require("../static/Íconos/Reservar.svg")} style={{ height: "15px", width: "15px" }} />
                                                        <Typography className={classes.typographyMenu}>
                                                            <FormattedMessage id="mis_reservas" />
                                                        </Typography>
                                                    </MenuItem>
                                                    <Divider />
                                                    <Divider />
                                                    <MenuItem onClick={handleClickLogout}>
                                                        <img alt="cerrar" src={require("../static/Íconos/Logout.svg")} style={{ height: "15px", width: "15px" }} />
                                                        <Typography className={classes.typographyMenu}>
                                                            <FormattedMessage id="cerrar_session" />
                                                        </Typography>
                                                    </MenuItem>
                                                    <Divider />
                                                </Menu>
                                            </>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justify="flex-start">
                                        {userLogin !== undefined && userLogin !== "undefined" && userLogin !== "" && (
                                            <Typography
                                                className={classes.userLogin}
                                                style={{
                                                    fontSize: "8pt",
                                                    marginTop: 5,
                                                }}
                                            >
                                                {userLogin.split("@")[0].slice(0, 15)}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item xs={2} container alignItems="center" justify="center">
                                    <img
                                        alt=""
                                        src={require("../static/Identificador/Logo hotel dorado.svg")}
                                        style={{
                                            height: "100px",
                                            width: "113px",
                                        }}
                                        onClick={handleClickHome}
                                    />
                                </Grid>
                                <Grid item xs={5} container alignItems="center" justify="flex-end">
                                    <IconButton onClick={handleDrawerClose} size="small">
                                        <img alt="Menu" src={svgMenu} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            {/* Label Menu */}
                            <Grid item container alignItems="center" justify="center">
                                <Grid item xs={4} />
                                <Grid item xs={4} container alignItems="center" justify="center">
                                    <Grid item xs={12} container alignItems="center" justify="center">
                                        <Typography className="textoMenu">
                                            <FormattedMessage id="menu" />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justify="center">
                                        <hr className="hrMenu" />
                                    </Grid>
                                </Grid>
                                <Grid item xs={4} />
                            </Grid>
                            {/* Inicio listado opciones del menu  */}
                            <List component="nav" aria-labelledby="nested-list-subheader" style={{ width: "100%" }}>
                                <ListItem button onClick={handleClickCatalogoHabitaciones}>
                                    <ListItemIcon>
                                        <img
                                            alt=""
                                            src={require("../static/Íconos/Habitación.svg")}
                                            style={{
                                                height: "17px",
                                                width: "17px",
                                            }}
                                        />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="habitaciones" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickReservar}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Cabaret parisien.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="cabaret_parisien" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickPromociones}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Ofertas.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titulo_promociones" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickRestaurantes}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Restaurantes.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titutlo_restaurante" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickBares}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Bares.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titutlo_bares" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickPiscinas}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Piscina-01.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titutlo_piscinas" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />

                                <ListItem button onClick={handleClickHistoria}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Historia.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="historia_m" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                {/* //? Work here areyesarean Eliminar enlace a eventos */}
                                {/* <ListItem button onClick={handleClickEventos}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Evento.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="eventos_m" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem> */}
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickNoticias}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/News.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titulo_comentarios_noticias_noticias" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickGaleria}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/image.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titulo_galeria_fotos" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickComentarios}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Chat dorado.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titulo_comentarios_noticias_comentarios" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickContactos}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Contacto.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="contactos" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickQuienesSomos}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Quiénes somos.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="titulo_quienes_somos" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                                <Divider className={classes.dividerItemMenu} />
                                <ListItem button onClick={handleClickTerminosCondiciones}>
                                    <ListItemIcon>
                                        <img alt="" src={require("../static/Íconos/Términos y condiciones.svg")} style={{ height: "17px", width: "17px" }} />
                                        <Typography variant="inherit" className={classes.textDrawer}>
                                            <FormattedMessage id="footer_terminos_condiciones2" />
                                        </Typography>
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            {/* Fin listado opciones del menu  */}
                        </Grid>
                        <Grid item xs={1} sm={2} />
                    </Grid>
                </Drawer>

                <Dialog
                    maxWidth="sm"
                    open={openConfrimacionLogout}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleClickCloseModalCerrarSesion();
                        }
                    }}
                    disableEscapeKeyDown={true}
                    aria-labelledby="max-width-dialog-title"
                    fullWidth
                >
                    <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                        <Grid item container xs={12}>
                            <Grid item xs={12} container justify="center" alignItems="center">
                                <img
                                    alt=""
                                    src={require("../static/Identificador/Logo hotel dorado.svg")}
                                    style={{
                                        height: "100px",
                                        width: "100px",
                                        marginBottom: 10,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} container justify="center" alignItems="center">
                                <Typography className={classes.textoHeader}>
                                    <FormattedMessage id="cerrar_session" />
                                </Typography>
                            </Grid>
                            <Grid item xs={12} container justify="center" alignItems="center">
                                <Divider className={classes.divider} />
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent className={classes.modalContent}>
                        <Grid item container xs={12} justify="center" alignItems="center">
                            <Typography className={classes.texto}>
                                <FormattedMessage id="estimado_cliente" />
                            </Typography>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.modalActions}>
                        <Grid item container xs={12} justify="center" alignItems="center" style={{ marginBottom: 20 }}>
                            <Button variant="contained" onClick={handleClickCloseModalCerrarSesion} className={classes.buttonModal} style={{ marginRight: ancho < 576 ? 0 : 10 }}>
                                <FormattedMessage id="aceptar" />
                            </Button>
                            <Button variant="contained" onClick={handleClickCancelModalCerrarSesion} className={classes.buttonModal} style={{ marginTop: ancho < 576 ? 10 : 0 }}>
                                <FormattedMessage id="cancelar" />
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </div>
    );
}
